import { useNavigate, useSearchParams } from "react-router-dom";
import { trackEvent } from "../utils/analytics";

export const CameraError: React.FC = () => {
  const nav = useNavigate();
  const [searchParams] = useSearchParams();

  let sessionIdParam = searchParams.get("s");
  let tableNumberParam = searchParams.get("t");
  let venueCode = searchParams.get("v");

  const handleGoBack = () => {
    nav(`/photo?s=${sessionIdParam}&t=${tableNumberParam}&v=${venueCode}`);
  };

  const handleChooseAvatar = () => {
    trackEvent({ gaEvent: "avatar_start" });
    nav(`/photo?s=${sessionIdParam}&t=${tableNumberParam}&v=${venueCode}&avatar=true`);
  };

  return (
    <div className="pageContainer">
      <div className="logoContainer">
        <img src={"./img/fc-logo.svg"} width="125px" alt="Flight Club" />
      </div>
      <div className="contentCard-outer">
        <div className="contentCard">
          <div className="errorContainer">
            <img src="./img/error-text.svg" alt="Error" />

            <div className="errorText">
              We need to access the camera to add your game face!
              <br /> Go back and grant permissions to continue
            </div>
            <div className="errorText">Camera not working? Why not select an avatar!</div>
            <button className="no-background chooseAvatarBtn" onClick={handleChooseAvatar}>
              Choose Avatar <img className="forward-arrow" src="./img/previous-arrow.svg" alt="" />
            </button>
          </div>
        </div>
        <span className="corner-bottom-left" />
        <span className="corner-bottom-right" />
      </div>
      <footer className="btn-container">
        <button className="small secondary with-back-arrow" onClick={handleGoBack}>
          <img className="previous-arrow" src="./img/previous-arrow.svg" alt="" />
          BACK
        </button>
      </footer>
    </div>
  );
};
